import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import CheckmarkCircleFill from '@elliemae/ds-icons/CheckmarkCircleFill';
import WarningCircleFill from '@elliemae/ds-icons/WarningCircleFill';
import InfoCircleFill from '@elliemae/ds-icons/InfoCircleFill';
import { ToastType, toastTypes } from './ToastType.js';

var blockName = 'toast-content';
var Container = aggregatedClasses('div')(blockName);
var IconContainer = aggregatedClasses('div')(blockName, 'icon-container');
var MessageContent = aggregatedClasses('div')(blockName, 'message-content');
var MessageHeader = aggregatedClasses('div')(blockName, 'message-header');
var MessageText = aggregatedClasses('span')(blockName, 'message-text');

var getIconByToastType = function getIconByToastType(type) {
  var _ToastType$SUCCESS$To;

  return (_ToastType$SUCCESS$To = {}, _defineProperty(_ToastType$SUCCESS$To, ToastType.SUCCESS, CheckmarkCircleFill), _defineProperty(_ToastType$SUCCESS$To, ToastType.WARNING, WarningCircleFill), _defineProperty(_ToastType$SUCCESS$To, ToastType.INFO, InfoCircleFill), _defineProperty(_ToastType$SUCCESS$To, ToastType.ERROR, WarningCircleFill), _defineProperty(_ToastType$SUCCESS$To, ToastType.DEFAULT, 'div'), _ToastType$SUCCESS$To)[type];
};

var ToastRender = function ToastRender(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? ToastType.DEFAULT : _ref$type,
      _ref$messageTitle = _ref.messageTitle,
      messageTitle = _ref$messageTitle === void 0 ? '' : _ref$messageTitle,
      _ref$messageText = _ref.messageText,
      messageText = _ref$messageText === void 0 ? '' : _ref$messageText;
  var IconMessage = aggregatedClasses(getIconByToastType(type))(blockName, 'icon-message');
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "ds-toast-render"
  }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(IconMessage, {
    size: "m"
  })), /*#__PURE__*/React.createElement(MessageContent, null, /*#__PURE__*/React.createElement(MessageHeader, null, messageTitle), /*#__PURE__*/React.createElement(MessageText, null, messageText)));
};

ToastRender.propTypes = {
  /**
   * Toast title
   */
  messageTitle: PropTypes.string.isRequired,

  /**
   * Toast body, either a string or Action with ActionLink component
   */
  messageText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /**
   * Toast type
   */
  type: PropTypes.oneOf(toastTypes).isRequired
};

export default ToastRender;
//# sourceMappingURL=ToastRender.js.map
